export enum AppRoutes {
    LOGIN = '/',
    LOGIN_PASSWORD = '/login-password',
    FORGOT_PASSWORD = '/forgot-password',
    SEARCH_MAP = 'search-map',
    AWARENESS_CAMPAIGNS = 'missions',
    DETAIL = 'detail',
    BATCH_DETAIL = 'batch-detail',
    SCAN_RFID ='scan-rfid',
    PROFILE = 'profile'
}